// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/poker-cards.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'poker-cards',
  version: 'outline',
  paths: [
    {
      d: 'M3.902 8.41c-.383-.917-.069-1.922.702-2.245l6.515-2.723c.771-.323 1.707.16 2.09 1.077l4.629 11.071c.383.917.07 1.922-.702 2.245l-6.515 2.723c-.77.323-1.707-.16-2.09-1.077z',
      strokeWidth: 1.8,
    },
    {
      d: 'M15.811 3.475c.664-.077 1.277.5 1.368 1.29l.554 4.769',
      strokeWidth: 1.8,
    },
    {
      d: 'M19.583 6.504c.668.145 1.07.905.898 1.7l-1.037 4.79',
      strokeWidth: 1.8,
    },
    {
      d: 'm11.752 11.35-.199 1.932-1.564-1.155.198-1.927z',
      strokeWidth: 1.8,
    },
  ],
}
